
<!-- ArticleDetailView.vue -->
<template>
  <v-navigation-drawer
    v-model="localDrawer5"
    class="py-0"
    :class="{'drawerOpen' : localDrawer5}"
    location="right"
    :width=" mobile ? width : userJS.articleDetailViewWidth.value"
    :style="{zIndex: mobile ? '600':'100'}"
    permanent
    persistent
    touchless
  >
    <!-- 상세보기 창 너비 조절 마우스 드래그 바 -->
    <div
      v-if="!mobile"
      id="dragbar"
      class="d-flex align-center"
      @mousedown="startDragging"
    >
      <v-icon
        id="dragbar-icon"
        size="small"
        color="#DBDBDB"
      >
        mdi-dots-vertical
      </v-icon>
    </div>

    <div id="articleDetailView_option">
      <v-toolbar
        color="background"
        class="my-2 mx-4 d-flex align-center"
        height="42"
      >
        <div class="mx-2 text-subtitle-1 font-weight-bold">
          기사 상세보기
        </div>

        <div v-if="userMobileStore.uiVisible.articleDetailView.tabList">
          <v-chip-group
            v-if="articleOptions.length"
            id="articleDetailViewChipGroup"
            v-model="articleOptionSelection"
            class="articleDetailChipGroup"
            :class="{ 'single-option': articleOptions.length === 1 }"
            selected-class="txt-co"
            mandatory
          >
            <v-chip
              v-for="articleOption in articleOptions"
              :key="articleOption.name"
              :ripple="false"
              class="mx-0"
              size="small"
              :prepend-icon="!mobile ? articleOption.icon : null"
              :text="articleOption.name"
              :value="articleOption.name"
              variant="outlined"
              :disabled="(isCuttingScrapData && articleOption.name !== '이미지')
                || (props.articleDetailViewData.mapUrlOnline == '' && articleOption.name === '온라인')
                || (!noContentByOption && (props.articleDetailViewData.TitleSub == '') && articleOption.name === '텍스트')"
              @click="articleOption.name === '이미지' ? showArticleDetailViewImage() : viewerDisplaynone()"
            />
          </v-chip-group>
        </div>

        <v-spacer />
        <!-- 기사 상세보기 창 닫기 버튼 -->
        <v-btn
          id="closeArticleDetailView"
          icon="mdi-window-close"
          :ripple="false"
          elevation="0"
          :height="40"
          :width="40"
          @click="$emit('change-drawer5', false); $emit('cancel-article-select')"
        />
      </v-toolbar>
    </div>

    <v-divider id="articleDetailView_divider" />

    <div
      id="articleDetailView_main"
      class="printable noHeaderHeight main-col"
      :style=" { overflowY: articleOptionSelection != '이미지' ? 'auto' : 'hidden' }"
      @scroll="shareSNSBtnMenu = false;"
    >
      <div
        id="articleDetailView_main_info"
        ref="mainInfo"
        :style="!mainInfoVisible ? { height: '0px', overflow: 'hidden', margin: '0', padding: '16px 0px 0px' } : null"
        class="viewhead"
      >
        <!-- 기사 제목 HTML code 처리가 필요하여 v-html로 처리 -->
        <p
          v-if="titleVisible"
          class="text-h4 print-text-h5"
          v-html="props.articleDetailViewData.Title"
        >
        </p>
        <div
          class="d-flex justify-space-between align-center viewinfo"
        >
          <div class="viewinfo-txt">
            <span
              v-for="(p, idx) in infoParts"
              :key="p.key"
              class="info-item"
            >
              <span :class="`mdi ${p.icon}`" />
              <span class="info-text">{{ p.text }}</span>
              <span
                v-if="idx < infoParts.length - 1"
                class="viewinfo-bar"
              >|</span>
            </span>
          </div>
          <div class="d-flex justify-center align-center">
            <!-- 버튼 : 디자인 후속작업 적용 -->
            <button
              v-if="articleOptionSelection == '온라인' && !mobile && orglinkVisible"
              id="openOriginalOnline_btn"
              class="d-flex btn1 flex-ct"
              type="button"
              @click="openOriginalOnline()"
            >
              <i
                class="mdi-open-in-new mdi v-icon notranslate v-icon--size-default"
                :class="presentTheme"
                aria-hidden="true"
              />
              기사 원문
            </button>

            <v-chip
              v-if="articleOptionSelection == '온라인' && mobile && orglinkVisible"
              id="openOriginalOnline_btn"
              class="me-1 px-1"
              rounded="xl"
              variant="outlined"
              :ripple="false"
              size="small"
              @click="openOriginalOnline();"
            >
              <v-icon>mdi-open-in-new</v-icon>
            </v-chip>
          </div>
        </div>

        <div class="mb-3">
          <v-chip-group
            id="articleDetailView_btns"
            v-model="setOneArticleData"
            multiple
          >
            <div v-if="!mobile && articleOptionSelection == '이미지' && bookmarkVisible && userStore.$isOption(props.roleSelection, 'scrap')">
              <v-tooltip
                location="bottom"
                transition="null"
                opacity="0"
                offset="7"
                width="74"
              >
                <template #activator="{ props: tooltip }">
                  <v-chip
                    :value="bookmarkedArticlePage"
                    class="btn2"
                    :class="{'bookmarkOn' : props.scrapSerialList.includes(isCuttingScrapData ? props.articleDetailViewData.scrapSeq : props.articleDetailViewData.Serial) }"
                    variant="outlined"
                    :disabled="!props.toggleScrapActive"
                    v-bind="tooltip"
                    @click="$emit('call-toggle-scrap', props.articleDetailViewData.Serial, props.articleDetailViewData.scrapSeq);"
                  >
                    <v-icon v-if="!props.scrapSerialList.includes(isCuttingScrapData ? props.articleDetailViewData.scrapSeq : props.articleDetailViewData.Serial)">
                      mdi-bookmark-outline
                    </v-icon>
                    <v-icon
                      v-if="props.scrapSerialList.includes(isCuttingScrapData ? props.articleDetailViewData.scrapSeq : props.articleDetailViewData.Serial)"
                      class="bookmarkOn"
                    >
                      mdi-bookmark
                    </v-icon>
                  </v-chip>
                </template>

                <!-- 툴팁 내용 -->
                <div
                  class="text-caption d-flex align-center"
                >
                  {{ !props.scrapSerialList.includes(isCuttingScrapData ? props.articleDetailViewData.scrapSeq : props.articleDetailViewData.Serial) ? '북마크 생성' : '북마크 삭제' }}
                </div>
              </v-tooltip>
            </div>
            <div v-if="mobile && articleOptionSelection == '이미지' && bookmarkVisible && userStore.$showFeature('scrap')">
              <v-tooltip
                location="bottom"
                transition="null"
                opacity="0"
                offset="7"
                width="74"
                :disabled="userJS.isHandheldDevice()"
              >
                <template #activator="{ props: tooltip }">
                  <v-chip
                    :value="bookmarkedArticlePage"
                    class="btn2 ms-2 px-1"
                    :class="{'bookmarkOn' : props.scrapSerialList.includes(isCuttingScrapData ? props.articleDetailViewData.scrapSeq : props.articleDetailViewData.Serial) }"
                    rounded="xl"
                    variant="outlined"
                    :ripple="false"
                    :disabled="!userStore.$isOption(props.roleSelection, 'scrap') ? true : !props.toggleScrapActive"
                    v-bind="tooltip"
                    @click="$emit('call-toggle-scrap', props.articleDetailViewData.Serial, props.articleDetailViewData.scrapSeq);"
                  >
                    <v-icon v-if="!props.scrapSerialList.includes(isCuttingScrapData ? props.articleDetailViewData.scrapSeq : props.articleDetailViewData.Serial)">
                      mdi-bookmark-outline
                    </v-icon>
                    <v-icon
                      v-if="props.scrapSerialList.includes(isCuttingScrapData ? props.articleDetailViewData.scrapSeq : props.articleDetailViewData.Serial)"
                      class="bookmarkOn"
                    >
                      mdi-bookmark
                    </v-icon>
                  </v-chip>
                </template>
                <!-- 툴팁 내용 -->
                <div
                  class="text-caption d-flex align-center"
                >
                  {{ !props.scrapSerialList.includes(isCuttingScrapData ? props.articleDetailViewData.scrapSeq : props.articleDetailViewData.Serial) ? '북마크 생성' : '북마크 삭제' }}
                </div>
              </v-tooltip>
            </div>

            <v-spacer />

            <v-tooltip
              v-if="articleOptionSelection == '이미지' && zoomButtonsVisible"
              location="bottom"
              transition="null"
              opacity="0"
              offset="7"
              width="74"
              :disabled="userJS.isHandheldDevice()"
            >
              <template #activator="{ props: tooltip }">
                <v-chip
                  id="zoomOutDetail"
                  class="btn2"
                  rounded="xl"
                  variant="outlined"
                  :ripple="false"
                  v-bind="tooltip"
                >
                  <v-icon style="position: absolute; display: block; left: 5.5px; top: 4px;">
                    mdi-minus
                  </v-icon>
                </v-chip>
              </template>
              <!-- 툴팁 내용 -->
              <div
                class="text-caption d-flex align-center"
              >
                이미지 축소
              </div>
            </v-tooltip>
            <v-tooltip
              v-if="articleOptionSelection == '이미지' && zoomButtonsVisible"
              location="bottom"
              transition="null"
              opacity="0"
              offset="7"
              width="74"
              :disabled="userJS.isHandheldDevice()"
            >
              <template #activator="{ props: tooltip }">
                <v-chip
                  id="zoomInDetail"
                  class="btn2"
                  rounded="xl"
                  variant="outlined"
                  :ripple="false"
                  v-bind="tooltip"
                >
                  <v-icon style="position: absolute; display: block; left: 6px; top: 4px;">
                    mdi-plus
                  </v-icon>
                </v-chip>
              </template>
              <!-- 툴팁 내용 -->
              <div
                class="text-caption d-flex align-center"
              >
                이미지 확대
              </div>
            </v-tooltip>
            <v-tooltip
              v-if="articleOptionSelection == '이미지' && zoomButtonsVisible"
              location="bottom"
              transition="null"
              opacity="0"
              offset="7"
              width="109"
              :disabled="userJS.isHandheldDevice()"
            >
              <template #activator="{ props: tooltip }">
                <v-chip
                  id="goHomeDetail"
                  class="btn2"
                  rounded="xl"
                  variant="outlined"
                  :ripple="false"
                  v-bind="tooltip"
                >
                  <v-icon style="position: absolute; display: block; left: 6px; top: 4px;">
                    mdi-fullscreen-exit
                  </v-icon>
                </v-chip>
              </template>
              <!-- 툴팁 내용 -->
              <div
                class="text-caption d-flex align-center"
              >
                이미지 크기 초기화
              </div>
            </v-tooltip>

            <!-- 글씨크기 조절 버튼 : hover시 background 변경되는 기능 css를 제대로 적용시키기 위해 button 태그 이용. -->
            <div
              v-if="fontSizeVisible"
              id="articleDetailView_textBtn"
              class="d-flex justify-space-center align-center"
            >
              <v-tooltip
                location="bottom"
                transition="null"
                opacity="0"
                offset="7"
                width="85"
                :disabled="userJS.isHandheldDevice()"
              >
                <template #activator="{ props: tooltip }">
                  <button
                    data-v-9cb76650=""
                    type="button"
                    class="btn2 btn-text"
                    v-bind="tooltip"
                    @click="textSizeData = Math.max(textSizeData - 1, 1);"
                  >
                    <span class="v-btn__content btn-txt-s">가</span>
                  </button>
                </template>

                <!-- 툴팁 내용 -->
                <div
                  class="text-caption d-flex align-center"
                >
                  글자 축소하기
                </div>
              </v-tooltip>

              <v-tooltip
                location="bottom"
                transition="null"
                opacity="0"
                offset="7"
                width="85"
                :disabled="userJS.isHandheldDevice()"
              >
                <template #activator="{ props: tooltip }">
                  <button
                    data-v-9cb76650=""
                    type="button"
                    class="btn2 btn-text"
                    v-bind="tooltip"
                    @click="textSizeData = Math.min(textSizeData + 1, 3)"
                  >
                    <span class="v-btn__content btn-txt-l">가</span>
                  </button>
                </template>

                <!-- 툴팁 내용 -->
                <div
                  class="text-caption d-flex align-center"
                >
                  글자 확대하기
                </div>
              </v-tooltip>
            </div>

            <div
              v-if="!mobile && printVisible"
              class="d-flex justify-space-center align-center"
            >
              <v-tooltip
                location="bottom"
                transition="null"
                opacity="0"
                offset="7"
                width="120"
              >
                <template #activator="{ props: tooltip }">
                  <v-chip
                    class="btn2"
                    variant="outlined"
                    :ripple="false"
                    v-bind="tooltip"
                    @click="printArticle()"
                  >
                    <v-icon>mdi-printer</v-icon>
                  </v-chip>
                </template>

                <!-- 툴팁 내용 -->
                <div
                  class="text-caption d-flex align-center"
                >
                  기사 이미지 인쇄하기
                </div>
              </v-tooltip>

              <div v-if="articleOptionSelection == '이미지' && downloadVisible && userStore.$isOption(props.roleSelection, 'download')">
                <!-- 저장 버튼 -->
                <v-tooltip
                  location="bottom"
                  transition="null"
                  opacity="0"
                  offset="7"
                  width="60"
                >
                  <template #activator="{ props: tooltip }">
                    <v-chip
                      class="btn2"
                      variant="outlined"
                      :ripple="false"
                      v-bind="tooltip"
                      @click="$emit('call-download-news-image', 'original', !isCuttingScrapData ? 1 : 2)"
                    >
                      <v-icon>mdi-download</v-icon>
                    </v-chip>
                  </template>

                  <!-- 툴팁 내용 -->
                  <div
                    class="text-caption d-flex align-center"
                  >
                    저장하기
                  </div>
                </v-tooltip>
              </div>

              <div v-if="articleOptionSelection == '텍스트' && downloadVisible && userStore.$isOption(props.roleSelection, 'download')">
                <!-- 저장 버튼 -->
                <v-tooltip
                  location="bottom"
                  transition="null"
                  opacity="0"
                  offset="7"
                  width="60"
                >
                  <template #activator="{ props: tooltip }">
                    <v-chip
                      class="btn2"
                      variant="outlined"
                      :ripple="false"
                      v-bind="tooltip"
                      @click="$emit('call-download-news-image', 'original', 'txt')"
                    >
                      <v-icon>mdi-download</v-icon>
                    </v-chip>
                  </template>

                  <!-- 툴팁 내용 -->
                  <div
                    class="text-caption d-flex align-center"
                  >
                    저장하기
                  </div>
                </v-tooltip>
              </div>

              <!-- sns 공유 버튼 -->
              <!-- 모바일에서는 scroll-strategy가 제대로 기능하지 않아 #articleDetailView_main 에 @scroll 이벤트 달아서 해결. -->
              <div v-if="articleOptionSelection == '온라인' && snsVisible">
                <v-menu
                  v-model="shareSNSBtnMenu"
                  :close-on-content-click="false"
                  location="bottom center"
                  scroll-strategy="close"
                  :offset="5"
                  width="320"
                  min-width="0"
                  :max-width="`${80*props.vw - 20}px`"
                >
                  <template #activator="{ props: shareSNSBtnProps }">
                    <v-tooltip
                      location="bottom"
                      transition="null"
                      opacity="0"
                      offset="7"
                      width="87"
                    >
                      <template #activator="{ props: tooltip }">
                        <v-chip
                          class="btn2"
                          variant="outlined"
                          :ripple="false"
                          v-bind="mergeProps(shareSNSBtnProps, tooltip)"
                          :disabled="props.articleDetailViewData.mapUrlOnline == ''"
                        >
                          <v-icon>mdi-share-variant-outline</v-icon>
                        </v-chip>
                      </template>
                      <!-- 툴팁 내용 -->
                      <div
                        class="text-caption d-flex align-center"
                      >
                        SNS 공유하기
                      </div>
                    </v-tooltip>
                  </template>

                  <v-sheet
                    class="pa-2"
                    style="border: solid 1px #E0E0E0;"
                    elevation="0"
                    width="320"
                    min-width="0"
                    :max-width="`${80*props.vw - 20}px`"
                  >
                    <ul class="d-flex justify-space-between">
                      <li
                        class="ma-2 d-flex flex-column align-center cursor-pointer"
                        @click="shareSNSBtnMenu = false; shareKakao();"
                      >
                        <v-img
                          :src="require('../../assets/images/SNSBtn/kakaotalkBtnIcon.png')"
                          width="40"
                          height="40"
                          cover
                        >
                          <!-- v-progress-circular: 이미지 로드 중 -->
                          <template #placeholder>
                            <v-row
                              class="fill-height fill-width ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="primary"
                              />
                            </v-row>
                          </template>
                        </v-img>
                        <p style="font-size: 13px; margin: 6px 0 0;">
                          카카오톡
                        </p>
                      </li>
                      <li
                        class="ma-2 d-flex flex-column align-center cursor-pointer"
                        @click="shareSNSBtnMenu = false; shareFacebook();"
                      >
                        <v-img
                          :src="require('../../assets/images/SNSBtn/facebookBtnIcon.png')"
                          width="40"
                          height="40"
                          cover
                          class="cursor-pointer"
                        >
                          <!-- v-progress-circular: 이미지 로드 중 -->
                          <template #placeholder>
                            <v-row
                              class="fill-height fill-width ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="primary"
                              />
                            </v-row>
                          </template>
                        </v-img>
                        <p style="font-size: 13px; margin: 6px 0 0;">
                          페이스북
                        </p>
                      </li>
                      <li
                        class="ma-2 d-flex flex-column align-center cursor-pointer"
                        @click="shareSNSBtnMenu = false; shareTwitter();"
                      >
                        <v-img
                          :src="require('../../assets/images/SNSBtn/twitterBtnIcon.jpg')"
                          width="40"
                          height="40"
                          cover
                          class="cursor-pointer"
                        >
                          <!-- v-progress-circular: 이미지 로드 중 -->
                          <template #placeholder>
                            <v-row
                              class="fill-height fill-width ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="primary"
                              />
                            </v-row>
                          </template>
                        </v-img>
                        <p style="font-size: 13px; margin: 6px 0 0;">
                          트위터
                        </p>
                      </li>
                      <li
                        class="ma-2 d-flex flex-column align-center cursor-pointer"
                        @click="shareSNSBtnMenu = false; shareNaverBand();"
                      >
                        <v-img
                          :src="require('../../assets/images/SNSBtn/naverBandBtnIcon.png')"
                          width="40"
                          height="40"
                          cover
                          class="cursor-pointer"
                        >
                          <!-- v-progress-circular: 이미지 로드 중 -->
                          <template #placeholder>
                            <v-row
                              class="fill-height fill-width ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="primary"
                              />
                            </v-row>
                          </template>
                        </v-img>
                        <p style="font-size: 13px; margin: 6px 0 0;">
                          네이버 밴드
                        </p>
                      </li>
                    </ul>
                    <div class="ma-2 d-flex align-center">
                      <input
                        id="articleUrlText"
                        type="text"
                        :placeholder="props.articleDetailViewData.mapUrlOnline =='' ? '온라인 기사가 없습니다.' : null"
                        :value="props.articleDetailViewData.mapUrlOnline"
                        style="width: 80%;"
                        readonly
                      >
                      <v-btn
                        class="ms-2"
                        :ripple="false"
                        elevation="0"
                        color="primary"
                        style="font-size: 13px; width: 20%"
                        @click="copyText()"
                      >
                        Url 복사
                      </v-btn>
                    </div>
                  </v-sheet>
                </v-menu>
              </div>
            </div>

            <div v-if="mobile">
              <!-- 저장 버튼 -->
              <div v-if="articleOptionSelection == '이미지' && downloadVisible && userStore.$isOption(props.roleSelection, 'download')">
                <v-tooltip
                  location="bottom"
                  transition="null"
                  opacity="0"
                  offset="7"
                  width="60"
                  :disabled="userJS.isHandheldDevice()"
                >
                  <template #activator="{ props: tooltip }">
                    <v-chip
                      class="btn2 px-1"
                      rounded="xl"
                      variant="outlined"
                      :ripple="false"
                      v-bind="tooltip"
                      @click="$emit('call-download-news-image', 'original', 1)"
                    >
                      <v-icon>mdi-download</v-icon>
                    </v-chip>
                  </template>

                  <!-- 툴팁 내용 -->
                  <div
                    class="text-caption d-flex align-center"
                  >
                    저장하기
                  </div>
                </v-tooltip>
              </div>
              <div v-if="articleOptionSelection == '텍스트' && downloadVisible && userStore.$isOption(props.roleSelection, 'download')">
                <v-tooltip
                  location="bottom"
                  transition="null"
                  opacity="0"
                  offset="7"
                  width="60"
                  :disabled="userJS.isHandheldDevice()"
                >
                  <template #activator="{ props: tooltip }">
                    <v-chip
                      class="btn2 px-1"
                      rounded="xl"
                      variant="outlined"
                      :ripple="false"
                      v-bind="tooltip"
                      @click="$emit('call-download-news-image', 'original', 'txt')"
                    >
                      <v-icon>mdi-download</v-icon>
                    </v-chip>
                  </template>

                  <!-- 툴팁 내용 -->
                  <div
                    class="text-caption d-flex align-center"
                  >
                    저장하기
                  </div>
                </v-tooltip>
              </div>

              <div v-if="articleOptionSelection == '온라인' && snsVisible">
                <!-- sns 공유 버튼 -->
                <v-menu
                  v-model="shareSNSBtnMenu"
                  :close-on-content-click="false"
                  location="bottom center"
                  :offset="5"
                  width="320"
                  min-width="0"
                  :max-width="`${90*props.vw}`"
                >
                  <template #activator="{ props: shareSNSBtnProps }">
                    <v-tooltip
                      location="bottom"
                      transition="null"
                      opacity="0"
                      offset="7"
                      width="87"
                      :disabled="userJS.isHandheldDevice()"
                    >
                      <template #activator="{ props: tooltip }">
                        <v-chip
                          class="btn2 px-1"
                          rounded="xl"
                          variant="outlined"
                          :ripple="false"
                          v-bind="mergeProps(shareSNSBtnProps, tooltip)"
                          :disabled="props.articleDetailViewData.mapUrlOnline == ''"
                        >
                          <v-icon>mdi-share-variant-outline</v-icon>
                        </v-chip>
                      </template>
                      <!-- 툴팁 내용 -->
                      <div
                        class="text-caption d-flex align-center"
                      >
                        SNS 공유하기
                      </div>
                    </v-tooltip>
                  </template>
                  <v-sheet
                    class="pa-2"
                    style="border: solid 1px #E0E0E0; overflow-x: hidden; transform: translateX(-10px);"
                    elevation="0"
                    width="320"
                    min-width="0"
                    :max-width="`${90*props.vw}`"
                  >
                    <ul class="d-flex justify-space-between">
                      <li
                        class="ma-2 d-flex flex-column align-center cursor-pointer"
                        @click="shareSNSBtnMenu = false; shareKakao();"
                      >
                        <v-img
                          :src="require('../../assets/images/SNSBtn/kakaotalkBtnIcon.png')"
                          width="40"
                          height="40"
                          cover
                        >
                          <!-- v-progress-circular: 이미지 로드 중 -->
                          <template #placeholder>
                            <v-row
                              class="fill-height fill-width ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="primary"
                              />
                            </v-row>
                          </template>
                        </v-img>
                        <p style="font-size: 13px; margin: 6px 0 0;">
                          카카오톡
                        </p>
                      </li>
                      <li
                        class="ma-2 d-flex flex-column align-center cursor-pointer"
                        @click="shareSNSBtnMenu = false; shareFacebook();"
                      >
                        <v-img
                          :src="require('../../assets/images/SNSBtn/facebookBtnIcon.png')"
                          width="40"
                          height="40"
                          cover
                          class="cursor-pointer"
                        >
                          <!-- v-progress-circular: 이미지 로드 중 -->
                          <template #placeholder>
                            <v-row
                              class="fill-height fill-width ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="primary"
                              />
                            </v-row>
                          </template>
                        </v-img>
                        <p style="font-size: 13px; margin: 6px 0 0;">
                          페이스북
                        </p>
                      </li>
                      <li
                        class="ma-2 d-flex flex-column align-center cursor-pointer"
                        @click="shareSNSBtnMenu = false; shareTwitter();"
                      >
                        <v-img
                          :src="require('../../assets/images/SNSBtn/twitterBtnIcon.jpg')"
                          width="40"
                          height="40"
                          cover
                          class="cursor-pointer"
                        >
                          <!-- v-progress-circular: 이미지 로드 중 -->
                          <template #placeholder>
                            <v-row
                              class="fill-height fill-width ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="primary"
                              />
                            </v-row>
                          </template>
                        </v-img>
                        <p style="font-size: 13px; margin: 6px 0 0;">
                          트위터
                        </p>
                      </li>
                      <li
                        class="ma-2 d-flex flex-column align-center cursor-pointer"
                        @click="shareSNSBtnMenu = false; shareNaverBand();"
                      >
                        <v-img
                          :src="require('../../assets/images/SNSBtn/naverBandBtnIcon.png')"
                          width="40"
                          height="40"
                          cover
                          class="cursor-pointer"
                        >
                          <!-- v-progress-circular: 이미지 로드 중 -->
                          <template #placeholder>
                            <v-row
                              class="fill-height fill-width ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="primary"
                              />
                            </v-row>
                          </template>
                        </v-img>
                        <p style="font-size: 13px; margin: 6px 0 0;">
                          네이버 밴드
                        </p>
                      </li>
                    </ul>
                    <div class="ma-2 d-flex align-center">
                      <input
                        id="articleUrlText"
                        type="text"
                        :placeholder="props.articleDetailViewData.mapUrlOnline =='' ? '온라인 기사가 없습니다.' : null"
                        :value="props.articleDetailViewData.mapUrlOnline"
                        style="width: 80%;"
                        readonly
                      >
                      <v-btn
                        class="ms-2"
                        :ripple="false"
                        elevation="0"
                        color="primary"
                        style="font-size: 13px; width: 20%;"
                        @click="copyText()"
                      >
                        Url 복사
                      </v-btn>
                    </div>
                  </v-sheet>
                </v-menu>
              </div>
            </div>
          </v-chip-group>
        </div>
        <v-divider />
      </div>

      <!-- height : 'calc(100% - 201px)', -->
      <div
        id="articleDetailView_main_content"
        class="main-content"
        :style="
          {
            margin : '0 16px 16px',
            height : `calc(100% - ${mainInfoHeight}px - 16px)`,
          }"
      >
        <div
          v-if="articleOptionSelection === '텍스트' && showNoContentMessageFromText"
          class="no-content-center"
        >
          해당 텍스트 컨텐츠가 없습니다.
        </div>
        <div
          v-if="articleOptionSelection === '온라인' && showNoContentMessageFromOnline"
          class="no-content-center"
        >
          해당 온라인 컨텐츠가 없습니다.
        </div>
        <!-- 이미지 로딩 중: '면 로딩 마스크'가 아닐 때에만 스피너 표시 -->
        <div
          v-if="articleOptionSelection === '이미지' && !detailViewLoadingSuccess && !isPageLoadingMaskVisible"
          style="max-height: 90%; height: 90%; display: flex; justify-content: center; align-items: center;"
          class="mt-10 mx-2"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="60"
          />
        </div>

        <!-- 이미지 래퍼: 뷰어 + 로딩마스크(면 로딩) -->
        <div
          v-show="articleOptionSelection === '이미지'"
          class="detail-viewer-wrap mx-2"
        >
          <!-- openseadragon 라이브러리로 기사 상세보기 창 - 기사 옵션 - 이미지 띄우는 영역 -->
          <!-- articleOptionSelection=='이미지'인 경우. -->
          <div
            v-show="detailViewLoadingSuccess"
            id="articleDetailViewImageViewer"
            class="osd"
            oncontextmenu=" event.preventDefault();"
          />

          <!-- 면 로딩 중일 때, 이미지 영역을 loadingpg.png로 덮는 오버레이 -->
          <div
            v-if="isPageLoadingMaskVisible"
            class="detail-loading-mask"
            :style="{ backgroundImage: `url(${loadingPaperImg})` }"
          />
        </div>

        <!-- 보이지 않는 인쇄 영역 -->
        <iframe
          class="printDiv"
          width="0"
          height="0"
          name="hiddenframe"
          style="display: none;"
        />
        <div
          v-if="articleOptionSelection=='텍스트' && !showNoContentMessageFromText"
          style="margin: 0 16px 0;"
        >
          <div
            style="word-break: keep-all;"
            :style="{
              width: !mobile ? '55%' : '60%',
            }"
            :class="currentTextSizeClass"
            class="print-content-text"
          >
            <p
              v-html="safeSubtitle"
            />
          </div>
          <br><br>
          <p
            v-if="noContentByOption"
            :class="currentTextSizeClass"
            class="print-content-text"
            v-html="safeContent"
          />
        </div>
        <div
          v-if="articleOptionSelection=='온라인' && !showNoContentMessageFromOnline"
          style="margin: 0 16px 0;"
        >
          <p
            v-if="articleOnlineData"
            :class="currentTextSizeClass"
            class="print-content-text"
            v-html="articleOnlineData"
          />
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script setup>
  import axios from "axios"
  import { ref, computed, onMounted, onBeforeUnmount, nextTick, watch, mergeProps } from 'vue';

  import { useTheme, useDisplay } from 'vuetify'
  const theme = useTheme();
  const presentTheme = computed(()=>{return 'v-theme--'+theme.global.name.value;})

  import OpenSeadragon from 'openseadragon';
  import sanitizeHtml from 'sanitize-html';
  import { useKakao } from 'vue3-kakao-sdk'
  import Konva from 'konva';
  import { useUserStore, useUserInfoStore, useUserAlertStore, useFuncStore, useUserMobileStore } from '@/store';
  const userStore = useUserStore();
  const userInfoStore = useUserInfoStore();
  const userAlertStore = useUserAlertStore();
  const funcStore = useFuncStore();
  const userMobileStore = useUserMobileStore();

  import { userJS } from '@/assets/js/index';

  const props = defineProps({
    vw: Number,
    drawer5: Boolean,
    articleDetailViewData: Object,
    scrapSerialList: Array,
    mediaName: String,
    mediaSeq: String,
    toggleScrapActive: Boolean,
    roleSelection: String,
    currentTheme: String,
    searchKeyword: Array,
  });
  const $emit = defineEmits(['next-article-page', 'call-toggle-scrap',
                            'change-drawer5', 'cancel-article-select', 'call-download-news-image',
                            'print-alert-to-true', 'share-s-n-s-alert-to-true',]);

  // 반응형 -> useDisplay API는 ref 타입의 name 속성을 반환
  const { mobile, width } = useDisplay();

  // v-model에 사용되는 props들은 이런 식으로 복사해서 사용할 것. --------------------------------------------------
  const localDrawer5 = ref(props.drawer5);
  watch(() => props.drawer5, (newVal) => {
    localDrawer5.value = newVal;
  });

  // 잘린 이미지 스크랩은 props.articleDetailViewData.value를 scrap 정보로 채우기 때문에.
  const isCuttingScrapData = computed(()=>{
    let scrapImgType = props.articleDetailViewData.imgType;
    return scrapImgType && scrapImgType == 2;
  });

  // 현재 선택된 탭 (칩 그룹 v-model) - 실제 값은 "라벨(한글)" 그대로 사용
  const articleOptionSelection = ref('');

  // 상세보기 탭(이미지/텍스트/온라인) 정의: 코드 + 라벨 + 아이콘
  const ARTICLE_DETAIL_OPTION_DEFS = {
    IMAGE: {
      code: 'IMAGE',
      name: '이미지',
      icon: 'mdi-image',
    },
    TEXT: {
      code: 'TEXT',
      name: '텍스트',
      icon: 'mdi-note-text-outline',
    },
    ONLINE: {
      code: 'ONLINE',
      name: '온라인',
      icon: 'mdi-earth-plus',
    },
  };

  // 모바일 레이아웃에서 articleDetailView.tabList 설정 가져오기
  const articleDetailTabLayout = computed(() => {
    const layout = userMobileStore.$getMobileLayout(
      mobile.value,
      'articleDetailView',
      'tabList',
    );
    return layout || {};
  });

  // articleDetailView.tabList.options 에 따라 실제 노출할 탭 목록 구성
  // options 가 비어 있으면 탭 버튼 아예 보이지 않도록.
  const articleOptions = computed(() => {
    const layout = articleDetailTabLayout.value;
    const optCodes = Array.isArray(layout.options) ? layout.options : [];

    return optCodes
      .map(code => ARTICLE_DETAIL_OPTION_DEFS[code] || null)
      .filter(Boolean);
  });
  function findArticleOptionByCode(code) {
    return articleOptions.value.find(opt => opt.code === code);
  }

  // firstView / options 를 고려해서 "초기 선택 탭 이름(한글)" 계산
  function computeInitialArticleTabName(layout) {
    const firstViewCode = layout?.firstView;

    // options가 비어있으면: =정의 테이블(ARTICLE_DETAIL_OPTION_DEFS)에서 firstView를 바로 찾는다.
    if (!articleOptions.value.length) {
      return ARTICLE_DETAIL_OPTION_DEFS[firstViewCode]?.name;
    }

    const optCodes = Array.isArray(layout?.options) ? layout.options : [];

    // 2) firstView 가 options 안에 있으면 firstView를 초기화면으로 사용
    if (firstViewCode && optCodes.includes(firstViewCode)) {
      return ARTICLE_DETAIL_OPTION_DEFS[firstViewCode]?.name;
    }

    // 3) firstView 설정값이 없거나, firstView가 options 안에 없으면 options[0] 사용
    return ARTICLE_DETAIL_OPTION_DEFS[optCodes[0]]?.name;
  }

  // 최초 1회: articleDetailView.tabList.firstView 기반으로 초기 탭 선택
  let articleDetailSelectionInitialized = false;
  watch(
    articleDetailTabLayout,
    (layout) => {
      if (articleDetailSelectionInitialized) return;

      const initialName = computeInitialArticleTabName(layout);

      articleOptionSelection.value = initialName;
      articleDetailSelectionInitialized = true;
    }
  );
  // PC → 모바일 전환 시, 현재 보고 있는 탭이 options 에 없으면 options[0] 으로 보정
  watch(
    () => mobile.value,
    (newVal, oldVal) => {
      // false → true 로 변할 때만 실행
      if (oldVal === false && newVal) {
        const opts = articleOptions.value;


        // 1) options가 아예 비었을 때 → firstView로 보여주기 (이미 computeInitialArticleTabName()에 의해 설정되어 있음)
        if (!opts.length) return;

        // 현재 보고 있던 상세보기 창 탭 화면이 options 안에 없으면 처리
        const allowedNames = opts.map(opt => opt.name);
        if (!allowedNames.includes(articleOptionSelection.value)) {
          // 2) options에 다른 옵션값들이 있을 때 → 그 중 첫 번째 값으로 보여주기
          articleOptionSelection.value = opts[0].name;
        }
      }
    },
  );

  // 모바일 레이아웃 설정 적용 ------------------------------------------------------------------------------------
  const currentDetailUi = computed(() => {
    const v = userMobileStore.uiVisible.articleDetailView;

    if (articleOptionSelection.value === '이미지') return v.image;
    if (articleOptionSelection.value === '텍스트') return v.text;
    return v.online; // '온라인'
  });

  // #articleDetailView_main_info 전체 노출 여부
  const mainInfoVisible = computed(() => {
    const ui = currentDetailUi.value || {};
    // 모바일 UI 설정상 해당 옵션 그룹이 통째로 숨김이면 main_info도 숨김
    return ui.isAllUiVisible !== false;
  });

  const titleVisible = computed(() => !!currentDetailUi.value?.title);

  const infoParts = computed(() => {
    const ui = currentDetailUi.value || {};
    const a = props.articleDetailViewData || {};

    const parts = [];

    if (ui.media && props.mediaName) {
      parts.push({ key: 'media', icon: 'mdi-newspaper-variant-outline', text: props.mediaName });
    }
    if (ui.page && a.PageName) {
      parts.push({ key: 'page', icon: 'mdi-book-open-page-variant-outline', text: a.PageName });
    }
    if (ui.category && a.Category) {
      parts.push({ key: 'category', icon: 'mdi-shape', text: a.Category });
    }
    if (ui.publishDate && a.Date) {
      parts.push({ key: 'publishDate', icon: 'mdi-clock-time-eight-outline', text: a.Date });
    }
    if (a.Reporter && a.Reporter) {
      parts.push({ key: 'reporter', icon: 'mdi-account-multiple', text: a.Reporter });
    }

    return parts;
  });

  const orglinkVisible = computed(() => {
    return articleOptionSelection.value === '온라인'
      && !!userMobileStore.uiVisible.articleDetailView.online.orglink;
  });

  const fontSizeVisible = computed(() => {
    if (articleOptionSelection.value === '텍스트') {
      return !!userMobileStore.uiVisible.articleDetailView.text.fontSize;
    }
    if (articleOptionSelection.value === '온라인') {
      return !!userMobileStore.uiVisible.articleDetailView.online.fontSize;
    }
    return false; // 이미지 탭은 fontSize 옵션이 없음(현재 customUI 스키마 기준)
  });

  const printVisible = computed(() => {
    const v = userMobileStore.uiVisible.articleDetailView;
    if (articleOptionSelection.value === '이미지') return !!v.image.print;
    if (articleOptionSelection.value === '텍스트') return !!v.text.print;
    return !!v.online.print;
  });

  const downloadVisible = computed(() => {
    const v = userMobileStore.uiVisible.articleDetailView;
    if (articleOptionSelection.value === '이미지') return !!v.image.detailImageDownload;
    if (articleOptionSelection.value === '텍스트') return !!v.text.detailImageDownload;
    return false;
  });

  const bookmarkVisible = computed(() => {
    return articleOptionSelection.value === '이미지'
      && !!userMobileStore.uiVisible.articleDetailView.image.bookmark;
  });

  const zoomButtonsVisible = computed(() => {
    return articleOptionSelection.value === '이미지'
      && !!userMobileStore.uiVisible.articleDetailView.image.zoomButtons;
  });

  const snsVisible = computed(() => {
    return articleOptionSelection.value === '온라인'
      && !!userMobileStore.uiVisible.articleDetailView.online.sns;
  });
  // /모바일 레이아웃 설정 적용 -----------------------------------------------------------------------------------

  const noContentByOption = computed(() => { // 기사가 광고, 공고인 경우 -> false
    const title = props.articleDetailViewData.Title;
    if(!title)
      return true;
    return !(title.includes('지면광고') || title.includes('전면광고') || title.includes('광고') || title.includes('공고'));
  });

  // 온라인 기사 원문 보기 버튼 ---------------------------------------------------------------------------------
  function openOriginalOnline(){
    window.open(
      props.articleDetailViewData.mapUrlOnline,
      "_blank",
    );
  }

  // 글씨 크기 버튼 --------------------------------------------------------------------------------------------
  const textSizeMenu = ref(false);
  const initialTextSizeData = 1;
  const textSizeData = ref(initialTextSizeData);
  const  currentTextSizeClass = computed(() => {
    return `text-size-${textSizeData.value}`;
  })
  // 인쇄 버튼에 적용되도록.
  const getTextSize1_print = {
    fontSize: '18px',
    lineHeight: '28.8px',
  }
  const getTextSize2_print = {
    fontSize: '21px',
    lineHeight: '33.6px',
  }
  const getTextSize3_print = {
    fontSize: '24px',
    lineHeight: '38.4px',
  }

  // 인쇄 버튼 --------------------------------------------------------------------------------------------------
  function printArticle() {                                                     // 프린트 영역 커스텀 장소 : @media print {}
    userAlertStore.$resetAllAlert();

    let windowObj = window.open(
      '',
      'hiddenframe',
      'width=0, height=0, toolbars=no, scrollbars=yes, status=no, resizable=no'
    );

    // 1) 이미지 인쇄
    let printDiv = document.querySelector('.printDiv');
    if(articleOptionSelection.value == '이미지') {
      // 정확히 printDiv 내부의 img만 제거
      if (printDiv) {
        const prevImgs = printDiv.querySelectorAll('.img');
        prevImgs.forEach(el => {
          if (el.parentNode === printDiv) {
            printDiv.removeChild(el);
          } else {
            el.remove?.();
          }
        });
      }
      const img = document.createElement('img');

      let imageAPIUrl = '';
      if(isCuttingScrapData.value) {// cutting 스크랩 이미지 불러오기
        imageAPIUrl = `${userJS.baseUrl}/user/scrap/cutDown/${props.articleDetailViewData.filename}`
      } else {
        let params = new URLSearchParams();
        params.append('mediaSeq', props.mediaSeq);
        params.append('filepath', props.articleDetailViewData.Serial);
        imageAPIUrl = `${userJS.baseUrl}/paperDown?${params.toString()}`;
      }

      // axios로 이미지(blob) 요청 → ObjectURL로 인쇄 (axios 인터셉터 통해 헤더에 Pmaster-Sid 포함시키기 위함.)
      axios.get(imageAPIUrl, {
        responseType: 'blob',
        withCredentials: true,
      }).then(({ data: blob }) => {
        const objectUrl = URL.createObjectURL(blob);

        img.src = objectUrl;
        img.classList.add('img');
        img.style.width = 'auto';
        img.style.height = 'auto';
        img.style.maxWidth = '100%';
        img.style.maxHeight = '100%';
        img.style.display = 'block';
        img.style.margin = '0 auto';
        printDiv.appendChild(img);

        windowObj.document.write(`
          <html>
            <head>
              <title>PrintNews</title>
            </head>
            <body>
              ${printDiv.innerHTML}
            </body>
          </html>
        `);

        windowObj.document.querySelector('.img').onload = function () {
          windowObj.print();
          try { URL.revokeObjectURL(objectUrl); } catch(e) {}
          windowObj.document.body.innerHTML = '';
          windowObj.close();
        };

        $emit('print-alert-to-true');
        return;                                                                      // 이미지 인쇄 후 printArticle() 함수 빠져나가기.
      }).catch(() => {
        alert('잘못된 다운로드 요청입니다.');
      });
      return;
    }

    // 2) 텍스트, 온라인 인쇄
    // 글씨 확대/축소 버튼 클릭 시 인쇄 화면에 적용되도록.
    let textSizeCss_print = {};
    let size = currentTextSizeClass.value;
    if(size == `text-size-1`) {
      textSizeCss_print = getTextSize1_print;
    } else if(size == `text-size-2`) {
      textSizeCss_print = getTextSize2_print;
    } else if(size == `text-size-3`) {
      textSizeCss_print = getTextSize3_print;
    }

    let printContent = document.getElementById('articleDetailView_main');          // 기사 상세보기 창 - 기사 내용
    windowObj.document.write(`
      <html>
        <head>
          <title>PrintNews</title>
          <style>
            @page {
              size: A4;
            }
            @media print {
              /* 프린트 스타일 추가 영역 */
              html, body {
                height: auto;
                margin: 0 !important;
                padding: 0 !important;
              }
              #articleDetailView_btns, #openOriginalOnline_btn, #articleDetailView_textBtn {
                display: none;
              }
              .print-text-h5 {
                font-size: 2.125rem;
                font-size: 1.5rem;
                font-weight: 600;
                line-height: 1.333;
                line-height: normal;
              }
              .print-content-text {
                font-size: ${textSizeCss_print.fontSize};
                line-height: ${textSizeCss_print.lineHeight};
              }
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);

    windowObj.print();
    windowObj.document.body.innerHTML = '';
    windowObj.close();

    $emit('print-alert-to-true');

  }

  // 공유 버튼 --------------------------------------------------------------------------------------------------
  const shareSNSBtnMenu = ref(false);

  const articleOnlineData = computed(()=>{// articleDetailViewData.value 변경 시 담아오는 온라인 기사 데이터
    let onlineText = props.articleDetailViewData.onlineContent;
    if(onlineText === '') {
      return null;
    }
    // 검색 결과(AND검색조건) 기사들의 serial 배열에 부합하는 기사들만 키워드 하이라이팅되도록.
    if(!userJS.searchResultSerialArr.value.includes(props.articleDetailViewData.Serial)) {
      return onlineText;
    } else {
      return onlineText.replaceAll(
        '<mark',
        `<mark style="background-color: ${userStore.searchHiColor}5c !important; color: #000;"`
      );
    }
  })
  // Kakao Talk 공유
  const { kakao } = useKakao();
  function shareKakao() {

    let host =
      window.location.hostname === 'localhost'
        ? 'https://api-server.scrapmaster.co.kr'
        : location.origin;

    kakao.value.Share.sendDefault({
      objectType: 'feed',
      content: {
        title: props.articleDetailViewData.Title,
        description: props.articleDetailViewData.TitleSub,
        imageUrl: `${host}/${process.env.VUE_APP_JAVA_SERVE_CONTEXT}/${userInfoStore.KAKAOIMG.replace(/^\//, '')}`,
        imageWidth: 800,
        imageHeight: 800,
        link: {
          mobileWebUrl: props.articleDetailViewData.mapUrlOnline,
          webUrl: props.articleDetailViewData.mapUrlOnline,
        },
      },
      buttons: [
        {
          title: '자세히 보기',
          link: {
            mobileWebUrl: props.articleDetailViewData.mapUrlOnline,
            webUrl: props.articleDetailViewData.mapUrlOnline,
          },
        },
      ],
    });
  }
  // Facebook 공유
	function shareFacebook() {
    if (!props.articleDetailViewData.mapUrlOnline) return;

    const title = props.articleDetailViewData.Title;
    const url = props.articleDetailViewData.mapUrlOnline;
    window.open(
      "http://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url) + "&title=" + encodeURIComponent(title),
      "_blank",              // 새로운 창에서 열기
      "width=600,height=600" // 창의 크기 및 기타 특성 설정
    );
  }
  // Twitter 공유
	function shareTwitter() {
    if (!props.articleDetailViewData.mapUrlOnline) return;

    const text = props.articleDetailViewData.Title;
    const url = props.articleDetailViewData.mapUrlOnline;
    window.open(
      "https://twitter.com/intent/tweet?text=" + encodeURIComponent(text) + "&url=" + encodeURIComponent(url),
      "_blank",
      "width=600,height=600"
    );
  }
  // Naverband 공유
	function shareNaverBand() {
    if (!props.articleDetailViewData.mapUrlOnline) return;

    const text = props.articleDetailViewData.Title;
    const url = props.articleDetailViewData.mapUrlOnline;
    window.open(
      "https://band.us/plugin/share?body=" + encodeURIComponent(text) + "&route=" + encodeURIComponent(url),
      "_blank",
      "width=600,height=800"
    );
  }

  // url 복사
  function copyText() {
    const textToCopy = props.articleDetailViewData.mapUrlOnline;
    if (textToCopy === '') return;

    const textarea = document.createElement('textarea');
    textarea.value = textToCopy;
    document.body.appendChild(textarea);

    textarea.select();
    const res = document.execCommand('copy');
    if(res){
      document.body.removeChild(textarea);
    // 모바일인 경우
    if (/android|webos|iphone|ipad|ipod|macintosh|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())) return;
    /* 알림창 띄우기*/
    userAlertStore.$resetAllAlert();
    $emit('share-s-n-s-alert-to-true');
    }
  }


  // XSS 공격 방지하기 위해 v-html 속성에 들어가는 값을 라이브러리 sanitize-html 사용해서 처리 --------------------------------------------
  // -> 사용자 입력값에서 <>태그가 존재했을 때 이를 제거해 주고 나머지 부분만 정상적인 데이터로 보내주는 역할
  let safeSubtitle = computed(() => {
    let content = props.articleDetailViewData.TitleSub;
    // '/withContent' api에서 키워드 하이라이팅 위치를 알려주는 태그 <mark>에 대해 style 적용시키기.
    content = content.replaceAll('<mark', `<mark style="background-color: ${userStore.searchHiColor}5c !important; color: #000;"`);
    let result = sanitizeHtml(content || '', {
      allowedTags: ['mark', 'br'],
      allowedAttributes: {
        mark: ['style'], // mark 태그에서 style 속성만 허용
      },
    });
    return result;
  });

  let safeContent = computed(() => {
    let content = props.articleDetailViewData.Content;

    // 검색 결과(AND검색조건) 기사들의 serial 배열에 부합하는 기사들만 키워드 하이라이팅되도록.
    if(!userJS.searchResultSerialArr.value.includes(props.articleDetailViewData.Serial)) {
      return content;
    } else {
      // '/withContent' api에서 키워드 하이라이팅 위치를 알려주는 태그 <mark>에 대해 style 적용시키기.
      content = content.replaceAll('<mark', `<mark style="background-color: ${userStore.searchHiColor}5c !important; color: #000;"`);
      let result = sanitizeHtml(content || '', {
        allowedTags: ['mark', 'br'],
        allowedAttributes: {
          mark: ['style'], // mark 태그에서 style 속성만 허용
        },
      });
      return result;
    }
  });

   // 상세보기창 마우스 드래그로 너비 조정 기능 구현 -------[start]-----------------------------------------------------------------------

  // 좌측헤더 폈을 때의 너비
  let maxWidth = width.value - 360;
  let minWidth = 450;

  function startDragging(e) {
    if (e.target.id === 'dragbar' || e.target.id === 'dragbar-icon') {
      e.preventDefault();
      dragging = true;
      document.addEventListener('mousemove', moveArticleDetailView);
      document.addEventListener('mouseup', stopDragging);
    }
    document.body.style.cursor = 'col-resize';                           // 드래그 상태에서 마우스 커서를 항상 col-resize로 변경
  }

  let dragging = false;
  let prevWidth = 0;
  function moveArticleDetailView(e) {
    if (dragging) {
      let mw = width.value - e.pageX;                                    // dragging = true -> 클릭한 상태
      if ( maxWidth <= mw) {
        userJS.articleDetailViewWidth.value = maxWidth;
      } else if ( minWidth >= mw ) {
        userJS.articleDetailViewWidth.value = minWidth;
      } else {
        userJS.articleDetailViewWidth.value = mw;
        let overlapCondition = userJS.isDrawerOverlap.value && userJS.articleDetailViewWidth.value > prevWidth;
        if(overlapCondition) {// 두 drawer가 overlap 되는 경우 좌측 메뉴 너비도 조절
          if (e.pageX <= 390) userJS.nestedDrawerWidth.value = 300; // 임의의 값 390 -> 기사 상세보기 창 최대로 늘릴 때 e.pageX 위치에 의해 좌측 메뉴가 완전한 최소 너비(300)가 안 되는 문제해결.
          else userJS.nestedDrawerWidth.value = width.value - userJS.articleDetailViewWidth.value - 60;
        }
      }
      prevWidth = userJS.articleDetailViewWidth.value;
    }
  }

  function stopDragging(e) {
    if (dragging) {
      dragging = false;
      document.removeEventListener('mousemove', moveArticleDetailView);
      document.removeEventListener('mouseup', stopDragging);

      document.body.style.cursor = 'auto';                          // 드래그가 끝나면 기본 커서로 변경
    }
  }
  // ---------------------------------------------------[end]------------------------------------------------------------------------------------------


  // 기사 상세보기 창 - 기사 옵션으로 이미지 선택 - openseadragon으로 이미지 띄움 --------------------------------------------------------------------------
  const viewerForArticleDetail= ref(null);

  // 기사 상세보기 창 이미지 보이기. openseadragon 라이브러리 사용 -----------------------------------------------------------------------------------------
  function articleDetailViewImageViewer_Start(){
    viewerForArticleDetail.value = new OpenSeadragon({
      id: "articleDetailViewImageViewer",
      prefixUrl: "//openseadragon.github.io/openseadragon/images/", // OpenSeadragon 라이브러리가 사용하는 이미지 파일들의 기본 경로
      tileSources:               [],
      panHorizontal:             true,                              // 이미지 수평방향 이동 가능 여부
      panVertical:               true,                              // 이미지 수직방향 이동 가능 여부
      springStiffness:           7.5,                               // 드래그 강도 설정. 기본값은 6.5
      animationTime:             0.8,                               // 애니메이션 시간 설정. 기본값은 1.2초. 드래그 정도에 영향을 줌
      constrainDuringPan:        true,                              // 이동 중 제약 여부
      visibilityRatio:           1,                                 // 가시도 비율. 드래그 시 이미지가 좌우상하 이동하는 정도를 조절.

      // defaultZoomLevel:       "",                                // 기본 확대 수준. 실제 이미지 크기를 viewport width와 상대적으로 표현. 1 -> 꽉 채움
      maxZoomPixelRatio:         2,                                 // 2 -> 원본 이미지의 실제 해상도(100%) 기준. 최대 200%까지 확대 가능.
      //maxZoomLevel:            mobile.value ? 5 : 1.5,            // OpenSeadragon의 타일 계층을 기준으로 최대 줌 레벨. 1 이상.
      maxZoomLevel:              "",                                // 최대 확대 수준. 1보다 큰 값.
      minZoomLevel:              "",                                // 최소 확대 수준. 1보다 작은 값.

      showZoomControl:           true,        // 이 속성을 false하면 스크롤 줌 기능도 불활성화되므로 아래에서 엘리먼트를 직접 삭제함.
      showHomeControl:           true,
      showFullPageControl:       false,
      zoomInButton:              "zoomInDetail",                    // 확대 버튼 ID
      zoomOutButton:             "zoomOutDetail",                   // 축소 버튼 ID
      homeButton:                "goHomeDetail",                    // 쪽맞춤 버튼 ID

      zoomPerClick:              1.01,                              // 기본값 2. 1에 가까워질수록 작은 비율로 확대됨.
                                                                    // updateScrollSettings()에서 스크롤 시 클릭기능(확대/축소) 호출하도록 해놨으므로 zoomPerClkick
      preserveImageSizeOnResize: false,
      // preserveViewport:          true,

      // 클릭하여 줌 인/아웃 기능 비활성화
      gestureSettingsMouse:{
        clickToZoom: false
      }
      ,gestureSettingsTouch: {
        clickToZoom: false
      },
      gestureSettingsPen: {
        clickToZoom: false
      }

    });

    // openseadragon에 의해 생기는 tooltip 제거
    if(document.getElementById('zoomInDetail') && document.getElementById('zoomOutDetail') && document.getElementById('goHomeDetail')) {
      document.getElementById('zoomInDetail').title = "";
      document.getElementById('zoomOutDetail').title = "";
      document.getElementById('goHomeDetail').title = "";
    }

    // showZoomControl 속성이 false일 때 -> openseadragon 라이브러리의 사용하지 않는 기사 상세보기 줌 인/아웃 버튼 제거
    // const articleDetailViewDiv = document.querySelector('div#articleDetailViewImageViewer');
    // if(articleDetailViewDiv){
    //   articleDetailViewDiv.querySelector('div[title="Zoom in"]').remove();
    //   articleDetailViewDiv.querySelector('div[title="Zoom out"]').remove();
    // }

    viewerForArticleDetail.value.addHandler('zoom', function() {
      const home = viewerForArticleDetail.value.viewport.getHomeZoom();
      // 홈 상태(홈 버튼 누른 상태)에서 줌아웃 비활성화
      viewerForArticleDetail.value.viewport.minZoomLevel = home;
    })


    viewerForArticleDetail.value.addHandler('canvas-scroll', function(event){// 스크롤 시작 & 종료
      // 마우스 휠로 줌 인/아웃 기능하도록.
      updateScrollSettings(event);
    })
  };

  // 마우스 휠 기능 정의
  function updateScrollSettings(event){
    // 스크롤 시 줌 인/아웃 버튼 클릭 이벤트를 걸었다.
    const isIn = event.scroll > 0 ? true : false;

      if( isIn ){
        event.eventSource.zoomInButton.onClick();
      } else {
        event.eventSource.zoomOutButton.onClick();
      }

  }

  // 줌 버튼의 줌 정도 조절하기 -> '줌버튼 클릭 한 번'과 '스크롤 한 번' 시 줌 인, 아웃 정도를 비슷하게 하기 위함.
  function adjustZoomInOutButtonsZoomlevels () {
    const zoomInButton = document.querySelector('#zoomInDetail');
    const zoomOutButton = document.querySelector('#zoomOutDetail');
    if (zoomInButton && zoomOutButton) {
      // 기본 클릭 이벤트 제거
      zoomInButton.onclick = null;
      zoomOutButton.onclick = null;
      // 커스텀 클릭 이벤트 추가
      const viewer = viewerForArticleDetail.value;
      if (viewer && viewer.viewport) {
        zoomInButton.addEventListener('click', () => {
            viewer.viewport.zoomBy(1.2);// 줌 정도를 1.2배로 증가
            viewer.viewport.applyConstraints(); // maxZoomLevel, minZoomLevel 적용하기.
        });
        zoomOutButton.addEventListener('click', () => {
            viewer.viewport.zoomBy(0.8);// 줌 정도를 1.2배로 증가
            viewer.viewport.applyConstraints(); // maxZoomLevel, minZoomLevel 적용하기.
        });
      }
    }
  }

  function bindHomeButton() {
    const viewer = viewerForArticleDetail.value;
    const homeBtn = document.querySelector('#goHomeDetail');
    if (!viewer?.viewport || !homeBtn) return;

    homeBtn.onclick = () => {
      // 홈으로 애니메이션 이동 (부드럽게)
      viewer.viewport.goHome(false);

      // 제약은 애니메이션이 끝난 뒤 한번만 적용하는게 자연스러움
      viewer.addOnceHandler?.('animation-finish', () => {
        viewer.viewport.applyConstraints();
      });
    };
  }

  const detailViewLoadingSuccess = ref(false);
  async function showArticleDetailViewImage(){
    let serial = props.articleDetailViewData.Serial;
    if (!serial || serial === "") return ;

    // 로딩 상태 초기화 - 새로운 이미지 로딩 전에 로딩 화면을 표시
    detailViewLoadingSuccess.value = false;

    if(!viewerForArticleDetail.value){// 매번 인스턴스 여러번 생성하지 않도록.
      articleDetailViewImageViewer_Start();
    }

    // 기존 이미지를 제거 == viewerForArticleDetail.value.source를 null로 바꿔줌.
    viewerForArticleDetail.value.close();

    let imageUrl ='';
    if(isCuttingScrapData.value) {// cutting 스크랩 이미지 불러오기
      imageUrl = `${userJS.baseUrl}/user/scrap/cutDown/${props.articleDetailViewData.filename}`
    } else {
      let params = new URLSearchParams();
      params.append('filepath', serial);
      params.append('mediaSeq', props.mediaSeq);
      imageUrl = `${userJS.baseUrl}/paperDown?${params.toString()}`;
    }

    try {
      // axios를 사용해 이미지(blob)로 다운로드 (인터셉터가 헤더 자동 부착)
      const { data: blob } = await axios.get(imageUrl, {
        responseType: 'blob',
        withCredentials: true, // 쿠키가 필요하면 유지
      });

      // Blob을 ObjectURL로 만들어 <img>에 주입
      const objectUrl = URL.createObjectURL(blob);

      // 새로운 이미지 로드
      let artImg = new Image();
      artImg.src = objectUrl;
      artImg.onload = function() {

        // 기사 선택이 더 빠른경우 이전 기사 이미지가 뒤늦게 로딩되어 기사 이미지 여러개가 겹쳐보이는 것을 방지.============
        // nextArticlePageForArrowKey()에서 articleDetailView.value.Serial과 비교하는 부분도 같은 기능임.

        if(isCuttingScrapData.value) {// cutting 스크랩 이미지를 불러오는 경우
          const filename = imageUrl.split('/user/scrap/cutDown/')[1];
          if(filename != props.articleDetailViewData.filename ) return;
        } else {
          // const paramsForCheck = new URLSearchParams(artImg.src.split('?')[1]);
          const query = imageUrl.split('?')[1] || '';
          const paramsForCheck = new URLSearchParams(query);
          const filepath = paramsForCheck.get('filepath');
          if(filepath != props.articleDetailViewData.Serial ) return;
        }

        //===========================================================================================================

        viewerForArticleDetail.value.addTiledImage({
          tileSource: {
            type: 'image',
            url: objectUrl,
          }
          ,fitBounds: new OpenSeadragon.Rect(0, 0, artImg.naturalWidth, artImg.naturalHeight)
          ,success: async function(event) {
            detailViewLoadingSuccess.value = true;

            // DOM이 보인 다음 프레임에 OSD 리사이즈/리드로우
            await nextTick();
            requestAnimationFrame(() => {
              const el = document.getElementById('articleDetailViewImageViewer');
              if (el && viewerForArticleDetail.value?.viewport) {
                const size = new OpenSeadragon.Point(el.clientWidth, el.clientHeight);
                viewerForArticleDetail.value.viewport.resize(size, true);
                viewerForArticleDetail.value.forceRedraw?.();
              }
              // 그 다음에 부가 작업 실행
              if (props.searchKeyword.length && userStore.$isOption(props.roleSelection, 'hilight')) { // 검색된 키워드 하이라이트
                isSearchResult();
              }
              adjustZoomInOutButtonsZoomlevels(); // 줌 버튼의 줌 정도 조절하기
              bindHomeButton();
            });

            // 사용이 시작되었으므로 ObjectURL 해제 (메모리 정리)
            try { URL.revokeObjectURL(objectUrl); } catch (e) {}

          }
          ,error: function(event) {
            console.log("error", event);
            // 실패 시에도 ObjectURL 해제
            try { URL.revokeObjectURL(objectUrl); } catch (e) {}
          }
        });
      }

      // onerror 핸들러 (blob 로드 실패 케이스)
      artImg.onerror = function (e) {
        console.error('이미지 로드 실패', e);
        try { URL.revokeObjectURL(objectUrl); } catch (e) {}
      };

    } catch (err) {
      // axios 호출 실패 처리
      console.error('이미지 요청 실패:', err);
      detailViewLoadingSuccess.value = false;
    }
  }

  function viewerDisplaynone(){
    // 탭 전환 시 화면만 가리기
    detailViewLoadingSuccess.value = false;
  }

  // PaperCenter.vue에서 /info.json 호출 시 응답 에러로 인해 대체 '로딩중...' 이미지 띄우는 동안
  // 상세(ArticleDetailView.vue)에서도 기사 이미지 위에 씌워놓을 png파일.
  const loadingPaperImg = require('../../assets/images/loadingpg.png');
  // 상세보기에서 사용할: 기사 시리얼 → 면(15자리) 시리얼
  const pageSerialOf = (serial) => serial?.substring(0, 15);

  // PaperCenter.vue가 올려둔 "해당 면 로딩중" 상태인지?
  const isPageLoadingMaskVisible = computed(() => {
    // 잘린 스크랩(개별 잘라낸 이미지)은 신문면 로딩 상태와 무관
    if (isCuttingScrapData.value) return false;
    // 이미지 탭일 때만 마스크 필요
    if (articleOptionSelection.value !== '이미지') return false;
    const pageSerial = pageSerialOf(props.articleDetailViewData?.Serial);
    if (!pageSerial) return false;
    // funcStore에 isPageLoading(pageSerial) 가 있다고 가정 (PaperCenter에서 $setPageLoading 사용)
    return !!funcStore.$isThatPageLoading?.(pageSerial);
  });

  // 2024.11.19 -> 기사 상세보기 창의 기사 이미지에서도 키워드 하이라이트 되도록. ====================================================================
  function searchKeywordHilight(shape) {
    funcStore.$keywordHilightPosision(viewerForArticleDetail.value, shape, 1);
  }
  let konvaStageD = null, canvasResizeCheck = [];

  // 키워드 하이라이팅 영역이 있다면 위치를 재조정하는 함수
  let konvaRaf = 0;
  function keywordLayersWhenResizing(viewer) {
    // 읽기
    const { x, y } = viewer.viewport.getContainerSize();
    const needResize = (canvasResizeCheck[0] !== x || canvasResizeCheck[1] !== y);
    // 쓰기는 다음 프레임으로
    cancelAnimationFrame(konvaRaf);
    konvaRaf = requestAnimationFrame(() => {
      konvaStageD?.children.forEach(stg => {
        stg.children.forEach(shape => searchKeywordHilight(shape));
      });
      if (needResize) {
        canvasResizeCheck = [x, y];
        konvaStageD?.setWidth(x);
        konvaStageD?.setHeight(y);
        viewer.containerresize = true;
      }
    });
  }
  watch(() => articleOptionSelection.value, (mode) => {
    if (mode !== '이미지') {
      // 이미지 숨김 상태에서는 라벨만 내려두고, 무거운 작업 skip
      viewerForArticleDetail.value && (viewerForArticleDetail.value.containerresize = false);
    }
  });

  // 검색 결과가 없습니다 처리하는 경우(noResult : true) 이전 하이라이트 모두 없애기
  watch(()=>userJS.noResult.value, (newVal)=>{
    if(newVal) {
      let keywordLayers = konvaStageD?.children.filter(child => child.attrs.type == 'keyword');
      keywordLayers?.forEach(child => child.destroy());
      userJS.searchHiShapesLayerD.value = null;
      return;
    }
  })
  function isSearchResult() {
    // konva 영역 생성
    let cCanvas = document.createElement('div');
    cCanvas.id = 'hilight-area';
    document.querySelector('#articleDetailViewImageViewer .openseadragon-canvas').appendChild(cCanvas);
    let viewer = viewerForArticleDetail.value;
    viewer.addHandler('animation', function(event) { // 뷰어 내부에서 줌이나 팬 애니메이션이 진행되는 동안 발생
      keywordLayersWhenResizing(viewer);
    });
    viewer.addHandler('resize', function(event) { // OpenSeadragon 뷰어의 컨테이너 크기가 변경될 때 발생
      keywordLayersWhenResizing(viewer);
    })

    //v4.1.0 부터 after-resize 존재
    //min zoom level reset
    viewer.addHandler('animation-finish', function(event){
      if( viewer.containerresize ){
        let minZoom = viewer.viewport.getHomeZoom(true);
        viewer.containerresize = false;
        viewer.viewport.minZoomLevel = minZoom;
        konvaStageD.setWidth(viewer.viewport.getContainerSize().x);
        konvaStageD.setHeight(viewer.viewport.getContainerSize().y);
        // 현재 줌 상태가 min zoom 보다 크면 그냥 둔다.
        if( viewer.viewport.getZoom() < minZoom){
          //홈으로 가야 된다면 주석 해제
          viewer.viewport.goHome();
        }
      }
    });

    if( konvaStageD ) konvaStageD.destroy();
    let odg = viewer.viewport.getContainerSize();
    let location = document.getElementById('articleDetailViewImageViewer').getBoundingClientRect();
    konvaStageD = new Konva.Stage({
      container: 'hilight-area',
      width: window.outerWidth - location.x,
      height: odg.y,
    });

    // 검색 결과(AND검색조건) 기사들의 serial 배열에 부합하는 기사들만 키워드 하이라이팅되도록.
    if(!userJS.searchResultSerialArr.value.includes(props.articleDetailViewData.Serial)) return;

    const scoors = props.articleDetailViewData.SearchWordCoordinate || {};
    const artAreas = props.articleDetailViewData.CoordinateList.Coordinate;
    let areaX = new Set(), areaY = new Set();
    artAreas.forEach((a, i) => {
      let point = a.split(',');
      areaX.add(point[0]);
      areaY.add(point[1]);
    });
    areaX = [...areaX].sort((a, b) => a - b)[0];
    areaY = [...areaY].sort((a, b) => a - b)[0];

    let ractToLine = (coors) => {
      let [x,y,x1,y1] = coors.split(',').map(
        (c,i) => {
          if( i % 2 == 0 ) c = c*1 - areaX;
          else  c = c*1 - areaY;
          return c;
        });
      return [ x, y, x1, y, x1, y1, x, y1, x, y ];
    }

    const shapesLayer = new Konva.Layer({type: 'keyword'});
    Object.keys(scoors).map((key) => {
      scoors[key].map((coords) => {
        let coors = ractToLine(coords);
        let shape = new Konva.Line({
          points: coors,
          orgPoints: coors,
          fill: userStore.searchHiColor,
          opacity: 0.5,
          unchanged: true,
          unclick: true,
          closed: true,
        });
        searchKeywordHilight(shape);
        shapesLayer.add(shape);
      });
    }); // scoors loop
    konvaStageD.add(shapesLayer);
    if(shapesLayer) userJS.searchHiShapesLayerD.value = shapesLayer; // userJS.updateSearchHiColorD()통해 기사 상세보기 창에서 하이라이트 색상 변경 사항을 바로바로 적용시키기 위함.
    else userJS.searchHiShapesLayerD.value = null;
  }

  watch(() => props.drawer5, (newVal) => {
    localDrawer5.value = newVal;
  });
  watch(()=>props.searchKeyword, (newVal)=>{// props.searchKeyword -> 배열임. 검색 결과 없으면 변경안됨.
    // 검색 키워드가 빈 문자가 아니고, 하이라이트 기능 사용 가능하며, 기사 상세보기 창이 열려있는 경우
    // 검색 결과 상의 검색 키워드(props.searchKeyword) 변경 시 기사 상세보기 하이라이트 다시 실행되도록
    if(newVal.length && userStore.$isOption(props.roleSelection, 'hilight') && localDrawer5.value) {
      let viewer = viewerForArticleDetail.value;
      viewer.removeHandler('animation');
      viewer.removeHandler('animation-finish');
      isSearchResult();
    }
  })
  // ============================================================================================================================================

  // "해당 컨텐츠가 없습니다." 표시 여부
  const showNoContentMessageFromText = ref(false);
  const showNoContentMessageFromOnline = ref(false);
  function refreshNoContentMessage(article) {
    const selected = articleOptionSelection.value;

    const noneOnline = (selected === '온라인' && (article?.mapUrlOnline ?? '') === '');
    const noneText = (
      selected === '텍스트'
      && (!noContentByOption.value && (article?.TitleSub ?? '') === '')
    );
    showNoContentMessageFromOnline.value = noneOnline;
    showNoContentMessageFromText.value = noneText;
  }

  // 상세보기 기사 변경 = 상세보기 데이터 갱신 시마다 처리.
  watch(() => props.articleDetailViewData, (newVal) => {
    // 초기 탭 결정
    const initialName = articleOptionSelection.value || computeInitialArticleTabName(articleDetailTabLayout.value);
    articleOptionSelection.value = initialName;

    // 광고/잘린스크랩이면 무조건 이미지로
    // - 광고 판단을 noContentByOption=false 로 쓰고 있으니 그대로 활용 가능
    if (isCuttingScrapData.value || !noContentByOption.value) {
      articleOptionSelection.value = '이미지';
    }

    // "해당 컨텐츠가 없습니다" 여부 갱신
    refreshNoContentMessage(newVal);

    // 이미지/그 외 처리
    if (articleOptionSelection.value !== '이미지') viewerDisplaynone();
    else showArticleDetailViewImage();
  });

  // ---------------------------------------------------------------------------------------------------------------------------------------------------
  function setDesignClass(){// 디자인 후속작업 적용.
    const chipGroupContainer1 = document.querySelector('#articleDetailViewChipGroup > .v-slide-group__container');
    if (chipGroupContainer1) {
      chipGroupContainer1.classList.add('tab');
    }
  }

  const mainInfoHeight = ref(0);
  let resizeObserver;
  const updateMainContentHeight = () => {
    const mainInfo = document.querySelector('#articleDetailView_main_info');
    // 초기값
    mainInfoHeight.value = Math.round(mainInfo.getBoundingClientRect().height);
    let rafId = 0;
    resizeObserver = new ResizeObserver((entries) => {
      const { height } = entries[0].contentRect;
      const next = Math.round(height);
      if (next === mainInfoHeight.value) return;
      // 관찰 콜백 안에서는 “읽기만” 하고, 쓰기는 다음 프레임에서
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        mainInfoHeight.value = next;
      });
    });
    resizeObserver.observe(mainInfo);
  }

  onMounted(() => {
    userJS.resetRight(minWidth, maxWidth, width.value);
    setDesignClass();
    updateMainContentHeight();
    window.addEventListener('resize', function(){// 브라우저 자체 resize 시 or 기사 상세보기 창 resize 시
      maxWidth = width.value - 360;// 현재 브라우저 창을 기준으로 갱신
      userJS.resetRight(minWidth, maxWidth, width.value);
    }, false);
  });

  onBeforeUnmount(() => {
    if (resizeObserver) resizeObserver.disconnect();// `ResizeObserver` 해제
  });
  // ---------------------------------------------------------------------------------------------------------------------------------------------------

    //기사 상세보기 북마크 버튼 관련 변수
    const setOneArticleData = ref([]);
    const bookmarkedArticlePage = ref('1');

</script>

<style scoped>
/* column 레이아웃 & 오버플로우 방지 */
.main-col {
  display: flex;
  flex-direction: column;
  min-height: 0; /* 자식이 퍼센트 높이로 커질 때 넘치지 않도록 */
}
.main-content {
  flex: 1 1 auto;
  min-height: 0;
}
/* 상세보기 이미지 영역 래퍼/마스크 */
.detail-viewer-wrap {
  position: relative;
  height: 100%;
  min-height: 0;
}
.osd {
  height: 100%;
  width: 100%;
  max-height: 100%;
}
.detail-loading-mask {
  position: absolute;
  inset: 0;
  background-color: #E0E8F9;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  z-index: 2; /* 뷰어 위로 */
  pointer-events: auto; /* 인터랙션 차단 (버튼은 상단 툴바에 있으므로 영향 없음) */
}

/* 디자인 후속작업 적용 */

/* 북마크 버튼 속성 무효화 */
#articleDetailView_btns .v-chip--size-default {
  --v-chip-size: initial;
  --v-chip-height: initial;
  font-size: 16px; /* 속성 추가 */
  padding: unset;
}

/* 글씨 크기 조절 버튼 속성 무효화 */
#articleDetailView_textBtn .v-btn--icon.v-btn--size-default {
  --v-btn-size: initial;
  font-size: 16px; /* 속성 추가 */
}
#articleDetailView_textBtn .v-btn {
  letter-spacing: .1rem; /* 속성 수정 */
}

/* 기사 상세보기 창 - 텍스트, 온라인 기사 데이터의 <mark>태그에 직접 스타일 입히기 */
mark {
  background-color: var(--hilight-color) !important;

  color: black;
}
/* 기사 상세보기 창 텍스트 아래로 padding 생기도록 */
#articleDetailView_main_content .print-content-text {
  padding-bottom: 16px;
}

.main-content {
  position: relative; /* 오버레이 기준 */
}
.no-content-center {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 15px;
  color: rgba(0,0,0,0.55);
  pointer-events: none; /* 스크롤/클릭 방해 방지 */
}
.viewinfo-txt {
  display: flex;
  align-items: center;
  flex-wrap: wrap;      /* 한 줄로 쭉 */
  gap: 0;                 /* 필요하면 4px~8px로 조절 */
  white-space: normal;    /* 줄바꿈 방지 */
}
.info-item {
  display: inline-flex;
  align-items: center;
}
.viewinfo-bar {
  margin: 0 8px;          /* 구분자 좌우 간격 */
}
.viewinfo-txt .mdi {
  margin-right: 4px;      /* 아이콘과 텍스트 간격 */
}

/* 상세보기 상단 탭: 옵션이 1개일 때 칩을 완전 타원형으로 */
.articleDetailChipGroup.single-option ::v-deep(.v-slide-group__container.tab .v-chip) {
  border-radius: 9999px !important;
}
.articleDetailChipGroup.single-option ::v-deep(.v-slide-group__container.tab .v-chip:first-child),
.articleDetailChipGroup.single-option ::v-deep(.v-slide-group__container.tab .v-chip:last-child) {
  border-radius: 9999px !important;
}

</style>

